import intToReal from '@helpers/intToReal';
import stringToSlug from '@helpers/stringToSlug';

class Product {
  constructor (data) {
    data = data || {}

    this.id = parseInt(data.productID) || null
    this.inventoryId = parseInt(data.productInventoryID) || null
    this.drawID = parseInt(data.drawID) || null
    this.drawNumber = parseInt(data.drawNumber) || null
    this.lotteryID = parseInt(data.lotteryID) || null
    this.productName = data.productName || null
    this.description = data.productDescription
    this.units = data.units || 0
    this.unitsInStock = data.unitsInStock || 0
    this.unitPrice = data.unitPrice || 0
    this.unitPriceText = intToReal(this.unitPrice)
    this.ticketStage = data.ticketStage || 0
    this.moreChances = data.moreChances || 0
    this.badge = data.badge || null
    this.serie = null
    this.domain = null
    this.badgeSlug = this.badge ? stringToSlug(this.badge) : null
    this.isEspecialOffer = data.isEspecialOffer || false
    this.isLandingOffer = data.isLandingOffer || false
    this.isFeaturedProduct = data.isFeaturedProduct || false
    this.detail = data.detail || null
    this.yourviews = null

    if (this.productName && this.lotteryID !== 5) {
      this.serie = this.productName.split('-').slice(-1)[0]
      this.domain = this.productName.split('-').slice(1, -1).join('-')
      this.yourviews = this.productName.split('-').slice(0, -1).join('-')
      this.domainComplete = this.productName.split('-').slice(0, -1).join('-')

      if (!this.domain) {
        this.domain = this.productName.split('-').slice(0, -1).join('-')
      }
    }

    if (this.productName && this.lotteryID === 5) {
      this.domain = this.productName
      this.yourviews = this.domain
      this.serie = '001'
    }
  }
}

export default Product;
